import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import URLs from '../../../../../utils/appURLs';
import { updateToast } from '../../../../../common/redux/reducer/commonSlices/toastSlice';
import axiosInstance from '../../../../../app/config/axiosInstance';

const serviceContext = process.env.REACT_APP_SERVICE_CONTEXT;

type Location = {
  lat: number;
  lng: number;
};

type NewGeofence = {
  vehicleNumber: string;
  geozoneID: string;
  geoType: string;
  latAndLong: Location[];
  radius: number;
  shapeColor: string;
  groupID: string;
  speedLimit: number;
  stoppageLimit: number;
};

type ReturnedType = {
  data: NewGeofence;
};

interface InitialState {
  isLoading: boolean;
  data: NewGeofence | null;
  error: string | null;
}

const initialState: InitialState = {
  isLoading: false,
  data: null,
  error: null
};

export const addGeofence = createAsyncThunk<ReturnedType, NewGeofence>(
  'user/geofences/add',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'POST',
        url: `${serviceContext}${URLs.ADD_GEOFENCE}`,
        data
      });
      return response.data.data;
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error?.response?.data?.message,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

const addGeofenceSlice = createSlice({
  name: 'addGeofence',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(addGeofence.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(
      addGeofence.fulfilled,
      (state, action: PayloadAction<ReturnedType>) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.error = null;
      }
    );
    builder.addCase(addGeofence.rejected, (state, action: any) => {
      state.error = action.error.message || 'Something went wrong';
    });
  }
});

export default addGeofenceSlice.reducer;
